module.exports = __webpack_public_path__ + "img/pPlusW.1f0606c1.png";